import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";

const Footer = () => {
  const [footerData, setFooterData] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  // ====================
  // Fetch Footer API (using axios)
  // ====================
  useEffect(() => {
    let cancelled = false;

    const fetchFooter = async () => {
      try {
        const res = await api.get("/api/global/footer");
        if (!cancelled) {
          setFooterData(res.data);
        }
      } catch (err) {
        if (!cancelled) {
          console.error("Footer API error:", err);
          // optionally setFooterData to a fallback structure or keep null
        }
      }
    };

    fetchFooter();

    return () => {
      cancelled = true;
    };
  }, []);

  // ====================
  // Scroll to Top Button
  // ====================
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY >= 350);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!footerData) return null;

  const { address, menu_columns, copyright_text, logo_url } = footerData;

  return (
    <>
      <div className="bottom-parallax">
        <footer className="footer-area">
          <div className="footer">
            <div className="container">
              <div className="row text-right-rtl">

                {/* =========================
                    ADDRESS COLUMN
                ========================== */}
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <div className="single-footer-widget marbtm50">
                    <div className="title wow fadeIn" data-wow-duration="2s">
                      <div className="dotted"></div>
                      <h2>{address.heading}</h2>
                    </div>

                    <div className="our-company-info">
                      <div className="text-box wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
                        <p>{address.content}</p>
                      </div>

                      <ul>
                        {address.links?.map((item, index) => (
                          <li key={index} className="wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
                            <div className="icon">
                              <i className={`fa ${item.icon_class} text-white fs-5`}></i>
                            </div>
                            <div className="text">
                              <Link to={item.url}>{item.text}</Link>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* =========================
                    DYNAMIC MENU COLUMNS
                ========================== */}
                {menu_columns.map((col, colIndex) => (
                  <div key={colIndex} className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                    <div className="single-footer-widget single-footer-widget--link-box marbtm50">
                      <div className="title wow fadeIn" data-wow-duration="2s">
                        <div className="dotted"></div>
                        <h2>{col.heading}</h2>
                      </div>

                      <div className="footer-widget-links">
                        <ul>
                          {(Array.isArray(col.links) ? col.links : Object.values(col.links)).map((link, linkIndex) => (
                            <li
                              key={linkIndex}
                              className="wow fadeIn"
                              data-wow-duration="2s"
                              data-wow-delay={`${(linkIndex + 1) * 0.2}s`}
                            >
                              <Link to={link.url}>
                                <span className="fa fa-asterisk"></span>
                                {link.text}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}

              </div>
            </div>
          </div>

          {/* =========================
              FOOTER BOTTOM
          ========================== */}
          <div className="footer-bottom">
            <div className="container">
              <div className="bottom-inner">

               

                <div className="footer-logo-style1 py-3 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
                  <Link to="#">
                    <img src={`${process.env.REACT_APP_API_URL}/public${logo_url}`} alt="Footer Logo" style={{ width: "200px" }} />
                  </Link>
                </div>

                 <div className="copyright wow fadeIn" data-wow-duration="2s">
                  <p dangerouslySetInnerHTML={{ __html: copyright_text }}></p>
                </div>

              </div>
            </div>
          </div>
        </footer>
      </div>

      {showScrollTop && (
        <button
          className="scroll-top scroll-to-target"
          onClick={scrollToTop}
          style={{ display: "block" }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            className="bi bi-arrow-up" viewBox="0 0 16 16">
            <path fillRule="evenodd"
              d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
            />
          </svg>
        </button>
      )}
    </>
  );
};

export default Footer;
